document.addEventListener('click', function(e){
  const card = e.target.closest('.bundle-card');

  if (!card) return;

  const value = card.dataset.variantValue;
  const fieldset = card.closest('.bundle-selector-fieldset');

  if (!fieldset) return;

  const radio = Array.from(
    fieldset.querySelectorAll(
      '.bundle-selector-hidden input[type="radio"]'
    )
  ).find(r => r.value === value);

  if (radio) radio.click();

  fieldset
    .querySelectorAll('.bundle-card')
    .forEach(card => card.classList.remove('active'));

  card.classList.add('active');
});

document.addEventListener('change', function(e){
  if (
    !e.target.matches(
      '.bundle-selector-hidden input[type="radio"]'
    )
  ) return;

  const value = e.target.value;
  const fieldset = e.target.closest(
    '.bundle-selector-fieldset'
  );

  if (!fieldset) return;

  fieldset
    .querySelectorAll('.bundle-card')
    .forEach(card => {
      card.classList.toggle(
        'active',
        card.dataset.variantValue === value
      );
    });
});
